import { Pipe, PipeTransform } from '@angular/core';
import { DocumentStatusesEnum } from './dto/document-statuses.enum';

@Pipe({
  name: 'documentStatusHelper',
})

/**
* get the badge class behalf on document status
*/
export class DocumentStatusHelperPipe implements PipeTransform {
  transform(status: DocumentStatusesEnum, classType:string = 'badge-light'): string {
    switch (status) {
        case DocumentStatusesEnum.Sent:
            return `badge-purple`;
        case DocumentStatusesEnum.Draft:
            return `${classType}-info`;
        case DocumentStatusesEnum.Uploaded:
            return `${classType}-info`;
        case  DocumentStatusesEnum.Delivered:
            return `${classType}-warning`;
        case DocumentStatusesEnum.Expired:
            return `${classType}-secondary`;
        case DocumentStatusesEnum.Revoke:
            return `${classType}-danger`;
        case DocumentStatusesEnum.Approved:
            return `${classType}-success`;
        case DocumentStatusesEnum.Signed:
            return `${classType}-success`;
        case DocumentStatusesEnum.Completed:
            return `${classType}-success`;
        case DocumentStatusesEnum.Viewed:
            return `${classType}-primary`;
        case DocumentStatusesEnum.Rejected:
            return `${classType}-danger`;
        case DocumentStatusesEnum.Failed:
            return `${classType}-secondary`;
        case DocumentStatusesEnum.Forwarded:
            return `${classType}-success`;
        case DocumentStatusesEnum.ReadOnly:
            return `${classType}-secondary`;
        case DocumentStatusesEnum.Waiting:
            return `${classType}-warning`;
        default:
            return '';
    }
  }
}
